import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom'
import { ToastContainer } from 'react-toastify';
import './App.scss';
import 'react-toastify/dist/ReactToastify.css';
import Home from './pages/Home';
import { useEffect } from 'react';
// import { isMobile } from './libs/userAgent';
import Terms from './pages/terms';
import PrivacyPolicy from './pages/privacy_policy';

function App() {

  useEffect(() => {
    // function handleResize() {
    //   if (!isMobile()) {
    //     window.location.reload();
    //   }
    // }
    // window.addEventListener('resize', handleResize)
    // return () => window.removeEventListener('resize', handleResize);
  }, [])
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy_policy" element={<PrivacyPolicy />} />
      </Routes>
      <ToastContainer theme="dark" autoClose={3000} hideProgressBar />
    </Router>
  );
}

export default App;
